export default ['/myht', '/myht/cggl']